import { Text as SambaText } from '@betterment/samba-react';

interface Props {
  children: React.ReactNode;
}

export function Text(props: Props) {
  const { children, ...restProps } = props;
  return (
    <SambaText
      variant="text50"
      css={{ overflow: 'hidden', textOverflow: 'ellipsis', color: 'primitives.white.100' }}
      {...restProps}
    >
      {children}
    </SambaText>
  );
}

Text.displayName = 'Nav.Text';
